var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Button } from 'components/Button';
import { ButtonGroup } from 'components/ButtonGroup';
import { FormField } from 'components/form/FormField';
import { FormGroup } from 'components/form/FormGroup';
import { FormSelect } from 'components/form/FormSelect';
import { Text } from 'components/Text';
import { React } from 'libs/react';
import { useState } from 'react';
import { CurrenciesQuery } from 'graphql/Currency/queries/CurrenciesQuery';
import { LanguagesQuery } from 'graphql/Language/queries/LanguagesQuery';
import { useAlert } from 'components/alert/AlertStack';
import { useQuery } from 'libs/react';
import { classNames } from 'libs/react';
import { DealActivityStream } from './sidebar/DealActivityStream';
import { DealNotesStream } from './sidebar/DealNotesStream';
import { PdfDownloadButton } from 'components/PdfDownloadButton';
import { useUser } from 'components/user/UserProvider';
import { Icon } from 'components/Icon';
import { DealReassignModal } from '../modal/DealReassignModal';
import { useTranslation } from 'components/translation/TranslationProvider';
import { EntityHistoryQuery } from 'graphql/EntityHistory/queries/EntityHistoryQuery';
import { Confirm } from 'components/confirm/Confirm';
import { useModal } from 'components/modal/ModalStack';
import { useDealConfiguratorContext } from '../DealConfigureScreen';
import { DateTime, toFormattedDate } from 'components/DateTime';
import { formatPlannedDateLabel } from 'helpers/formatPlannedDateLabel';
import { useRoute } from 'components/router/Routing';
import { DealModalEditTitle } from './modal/DealModalEditTitle';
import { useAccount } from 'components/account/AccountProvider';
import { getConfigurationFieldValue } from 'helpers/ConfigurationField';
import { Requires } from 'components/user/Requires';
import { gql } from '@apollo/client';
import { getStatusOptions } from 'components/StatusSelect';
import { useMergedDealStageOptions } from 'components/StageSelect';
import { Status } from 'components/Status';
import './DealSidebar.scss';
/**
 * @component DealSidebar
 * @since 1.0.0
 */
export function DealSidebar(props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s;
    const { style, deal, activityStreamEntityType, onSaveDraft, onPublish, isPublish, isQuote, setActivityStreamSideBar, saveDraftProcessing, setDealUser, setDealPartner, setDealPartnerContact, setLanguage, dealUser } = Object.assign({ style: 'normal' }, props);
    const [activityStream, setActivityStream] = useState(false);
    const [notesStream, setNotesStream] = useState(false);
    const [openModalAssignTo, setOpenModalAssignTo] = useState(false);
    const [openModalVersion, setOpenModalVersion] = useState(false);
    const [openModalTitle, setOpenModalTitle] = useState(false);
    const [currency, setCurrency] = useState(deal.currency.id);
    const [entityType, setEntityType] = useState(activityStreamEntityType !== null && activityStreamEntityType !== void 0 ? activityStreamEntityType : 'HISTORY');
    const alert = useAlert();
    const user = useUser();
    const modal = useModal();
    const generate = useRoute();
    const account = useAccount();
    const { customLabels, language } = useTranslation();
    const hasPDF = getConfigurationFieldValue((_a = account.configs) !== null && _a !== void 0 ? _a : [], 'HAS_PDF');
    let hasChat = getConfigurationFieldValue((_b = account.configs) !== null && _b !== void 0 ? _b : [], 'CHAT_ENABLED');
    if (user.user &&
        [
            'ce6fb37bb3f9472d840b4a828cc7468d',
            '2050849d1fda4daa88d234718356769d',
            'a5cb986c7fbc47c2b75ccd302dc82fe0',
            'aab79aee46b9493884ef73687a1fcd88',
            '3b1931fa2b8543fb85d31f02c8e1ecce'
        ].includes((_c = user.user) === null || _c === void 0 ? void 0 : _c.id)) {
        hasChat = 'TRUE';
    }
    else {
        hasChat = 'FALSE';
    }
    const { updateCurrency } = useDealConfiguratorContext();
    let users = [];
    if (!isQuote && (!user.isContactUser() || user.isManager())) {
        const [usersData] = useQuery(gql `
        query UserListQuery($input: UsersInput!) {
          users(input: $input) {
            items {
              id
              fullname
              email
            }
          }
        }
      `, {
            variables: {
                input: {}
            }
        });
        users = (_d = usersData === null || usersData === void 0 ? void 0 : usersData.users.items) !== null && _d !== void 0 ? _d : [];
    }
    const [entityData] = useQuery(EntityHistoryQuery, {
        variables: {
            input: {
                entity: 'DEAL',
                entityId: (_e = deal === null || deal === void 0 ? void 0 : deal.id) !== null && _e !== void 0 ? _e : ''
            }
        },
        fetchPolicy: 'network-only',
        skip: !activityStream
    });
    const [currenciesData] = useQuery(CurrenciesQuery, {
        fetchPolicy: 'network-only',
        skip: isQuote
    });
    const [languagesData] = useQuery(LanguagesQuery, {
        fetchPolicy: 'network-only',
        skip: isQuote
    });
    const canPublish = deal.items.filter((item) => !item.proposed).length > 0 &&
        !!(deal.contact || deal.client);
    const canSaveDraft = deal.items.filter((item) => !item.proposed).length > 0 ||
        !!(deal.contact || deal.client);
    const dealStageOptions = useMergedDealStageOptions();
    const stage = dealStageOptions.find((stage) => stage.value === (deal === null || deal === void 0 ? void 0 : deal.stage));
    const status = getStatusOptions(deal.type === 'AGREEMENT' ? 'AGREEMENT' : 'DEAL').find((status) => status.value === (deal === null || deal === void 0 ? void 0 : deal.status));
    let validityPeriodEndDate = null;
    if (deal.validityPeriod && deal.date) {
        const expiration = new Date(deal.date);
        expiration.setDate(expiration.getDate() + deal.validityPeriod);
        validityPeriodEndDate = toFormattedDate(expiration, {
            y: 'numeric',
            m: 'numeric',
            d: 'numeric'
        });
    }
    /**
     * @function onPressCopy
     * @since 1.0.0
     * @hidden
     */
    const onPressCopy = () => {
        const baseUrl = window.location.origin;
        navigator.clipboard.writeText(`${baseUrl}/interactive-quote/${deal.id}`);
        alert.present({
            title: React.createElement("p", null, t('The link of the quote has been copied.'))
        });
    };
    /**
     * @function onPressPreview
     * @since 1.0.0
     * @hidden
     */
    const onPressPreview = () => {
        const link = document.createElement('a');
        link.href = generate.gen({
            name: 'quote',
            data: { id: deal.id, preview: 'preview' }
        });
        link.target = '_blank';
        link.click();
    };
    /**
     * @function onPressActivity
     * @since 1.0.0
     * @hidden
     */
    const onPressNotes = () => {
        setNotesStream(true);
    };
    const onPressActivity = () => {
        setActivityStream(true);
        setEntityType('HISTORY');
    };
    const onPressChat = () => {
        setActivityStream(true);
        setEntityType('CHAT');
    };
    /**
     * @function onClickEdit
     * @since 1.0.0
     * @hidden
     */
    const onClickEdit = () => {
        setOpenModalAssignTo(true);
    };
    /**
     * @function onClickVersion
     * @since 1.0.0
     * @hidden
     */
    const onClickVersion = () => {
        setOpenModalVersion(true);
    };
    /**
     * @function onClose
     * @since 1.0.0
     * @hidden
     */
    const onClose = () => {
        if (openModalAssignTo) {
            setOpenModalAssignTo(false);
        }
        if (openModalVersion) {
            setOpenModalVersion(false);
        }
        if (openModalTitle) {
            setOpenModalTitle(false);
        }
    };
    /**
     * @function onConfirmReassign
     * @since 1.0.0
     * @hidden
     */
    const onConfirmReassign = (userId, partnerId, partnerContactId) => {
        setDealUser && setDealUser(userId);
        setDealPartner && setDealPartner(partnerId);
        setDealPartnerContact && setDealPartnerContact(partnerContactId);
        onClose();
    };
    /**
     * @function onClickEditTitle
     * @since 1.0.0
     * @hidden
     */
    const onClickEditTitle = () => {
        setOpenModalTitle(true);
    };
    /**
     * @function onCurrencyChange
     * @since 1.0.0
     * @hidden
     */
    const onCurrencyChange = (value) => {
        /**
         * @function execute
         * @hidden
         * @since 1.0.0
         */
        function execute() {
            return __awaiter(this, void 0, void 0, function* () {
                setCurrency(value);
                const currency = currenciesData === null || currenciesData === void 0 ? void 0 : currenciesData.currencies.find((c) => c.id === value);
                currency && updateCurrency(currency);
            });
        }
        modal.present({
            style: 'dialog',
            title: t('Confirm'),
            picto: 'check',
            modal: (React.createElement(Confirm, { title: `${t('Update Currency')} ?`, infos: t('Are you sure you want to update the currency? Markups will be reset.'), onAccept: execute }))
        });
    };
    const className = classNames('deal-sidebar', 'deal-sidebar--' + style, props.className);
    return (React.createElement("div", { className: className }, notesStream ? (React.createElement(DealNotesStream, { deal: deal, setNotesStream: setNotesStream })) : !activityStream && !isQuote ? (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "deal-sidebar-head" },
            React.createElement("div", { className: "deal-sidebar-title" },
                React.createElement("div", { className: "deal-sidebar-infos click-edit", onClick: onClickEditTitle },
                    React.createElement("div", { className: "deal-sidebar-value-container" },
                        React.createElement(Text, { style: "deal-sidebar-infos-text", value: deal.title }),
                        React.createElement(Icon, { value: "pen-to-square" })))),
            React.createElement("div", { className: "deal-sidebar-infos" },
                React.createElement(Text, { style: "deal-sidebar-infos-title", value: deal.type === 'AGREEMENT' ? t('Agreement') : t('Quote') }),
                React.createElement(Text, { style: "deal-sidebar-infos-text", value: deal.number })),
            React.createElement("div", { className: "deal-sidebar-infos" },
                React.createElement(Status, { color: (_f = status === null || status === void 0 ? void 0 : status.color) !== null && _f !== void 0 ? _f : 'green', label: (_g = status === null || status === void 0 ? void 0 : status.label) !== null && _g !== void 0 ? _g : 'N/A' }),
                React.createElement(Status, { color: (_h = stage === null || stage === void 0 ? void 0 : stage.color) !== null && _h !== void 0 ? _h : 'green', label: (_j = stage === null || stage === void 0 ? void 0 : stage.label) !== null && _j !== void 0 ? _j : 'N/A' })),
            React.createElement("div", { className: "deal-sidebar-tools" },
                React.createElement(ButtonGroup, null,
                    React.createElement("div", { className: "deal-sidebar-tool-container" },
                        React.createElement(Button, { style: "picto", picto: "note-sticky", onPress: onPressNotes, className: "deal-sidebar-tool" }),
                        React.createElement(Text, { className: "deal-sidebar-tool-value", value: t('Notes') })),
                    hasChat === 'TRUE' && (React.createElement("div", { className: "deal-sidebar-tool-container" },
                        React.createElement(Button, { style: "picto", picto: "comments", onPress: onPressChat, className: "deal-sidebar-tool" }),
                        React.createElement(Text, { className: "deal-sidebar-tool-value", value: t('Chat') }))),
                    React.createElement("div", { className: "deal-sidebar-tool-container" },
                        React.createElement(Button, { style: "picto", picto: "eye", onPress: onPressPreview, className: "deal-sidebar-tool" }),
                        React.createElement(Text, { className: "deal-sidebar-tool-value", value: t('Preview this quote') })),
                    React.createElement("div", { className: "deal-sidebar-tool-container" },
                        React.createElement(Button, { style: "picto", picto: "link", onPress: onPressCopy, className: "deal-sidebar-tool" }),
                        React.createElement(Text, { className: "deal-sidebar-tool-value", value: t('Copy public quote link') })),
                    React.createElement("div", { className: "deal-sidebar-tool-container" },
                        React.createElement(Button, { style: "picto", picto: "clock-rotate-left", onPress: onPressActivity, className: "deal-sidebar-tool" }),
                        React.createElement(Text, { className: "deal-sidebar-tool-value", value: t('History') })),
                    hasPDF === 'TRUE' && (React.createElement("div", { className: "deal-sidebar-tool-container" },
                        React.createElement(PdfDownloadButton, { dealId: deal === null || deal === void 0 ? void 0 : deal.id, className: "deal-sidebar-tool button" }),
                        React.createElement(Text, { className: "deal-sidebar-tool-value", value: t('Download PDF') })))))),
        React.createElement("div", { className: "deal-sidebar-body" },
            React.createElement("div", { className: "deal-sidebar-form" },
                React.createElement("div", { className: "deal-sidebar-infos" },
                    React.createElement(Text, { style: "deal-sidebar-infos-title", value: t('Last update') }),
                    React.createElement("div", { className: "deal-sidebar-value-container" },
                        React.createElement(DateTime, { style: "deal-sidebar-infos-text", value: (_k = deal === null || deal === void 0 ? void 0 : deal.updatedAt) !== null && _k !== void 0 ? _k : deal.createdAt, y: "numeric", m: "numeric", d: "numeric" }))),
                React.createElement("div", { className: "deal-sidebar-infos" },
                    React.createElement(Text, { style: "deal-sidebar-infos-title", value: t('Date') }),
                    React.createElement(Text, { style: "deal-sidebar-infos-text", value: formatPlannedDateLabel(deal.plannedDateStart, deal.plannedDateEnd) })),
                deal.validityPeriod && (React.createElement("div", { className: "deal-sidebar-infos" },
                    React.createElement(Text, { style: "deal-sidebar-infos-title", value: t('Validity period') }),
                    React.createElement(Text, { style: "deal-sidebar-infos-text", value: deal.validityPeriod +
                            ' ' +
                            t('days') +
                            (validityPeriodEndDate
                                ? ` (${validityPeriodEndDate})`
                                : '') }))),
                React.createElement("div", { className: "deal-sidebar-infos" },
                    React.createElement(Text, { style: "deal-sidebar-infos-title", value: customLabels['Contact'][language] }),
                    React.createElement(Text, { style: "deal-sidebar-infos-text", value: (_l = deal.contact) === null || _l === void 0 ? void 0 : _l.fullname })),
                React.createElement("div", { className: "deal-sidebar-infos" },
                    React.createElement(Text, { style: "deal-sidebar-infos-title", value: customLabels['Client'][language] }),
                    React.createElement(Text, { style: "deal-sidebar-infos-text", value: (_m = deal.client) === null || _m === void 0 ? void 0 : _m.name })),
                React.createElement(FormGroup, null,
                    React.createElement(FormField, null,
                        React.createElement(FormSelect, { className: "deal-sidebar-infos-title", name: "currency", size: "small", style: "seamless", label: t('Currency'), options: (_o = currenciesData === null || currenciesData === void 0 ? void 0 : currenciesData.currencies.filter((c) => c.enabled).map((currency) => ({
                                value: currency.id,
                                label: currency.code
                            }))) !== null && _o !== void 0 ? _o : [], value: currency, onChange: (value) => {
                                onCurrencyChange(value);
                            } }))),
                React.createElement(FormGroup, null,
                    React.createElement(FormField, null,
                        React.createElement(FormSelect, { className: "deal-sidebar-infos-title", name: "language", size: "small", style: "seamless", label: t('Language'), options: (_p = languagesData === null || languagesData === void 0 ? void 0 : languagesData.languages.filter((l) => l.enabled).map((language) => ({
                                value: language.code,
                                label: language.name
                            }))) !== null && _p !== void 0 ? _p : [], value: (_q = deal.language) !== null && _q !== void 0 ? _q : 'en', onChange: (value) => {
                                setLanguage && setLanguage(value);
                            } }))),
                deal.partner && (React.createElement("div", { className: "deal-sidebar-infos" },
                    React.createElement(Text, { style: "deal-sidebar-infos-title", value: t('Partner') }),
                    React.createElement(Text, { style: "deal-sidebar-infos-text", value: deal.partner.name }))),
                (!user.isContactUser() || user.isManager()) && (React.createElement("div", { className: "deal-sidebar-infos click-edit", onClick: onClickEdit },
                    React.createElement(Text, { style: "deal-sidebar-infos-title", value: t('Owned By') }),
                    React.createElement("div", { className: "deal-sidebar-value-container" },
                        React.createElement(Text, { style: "deal-sidebar-infos-text", value: dealUser
                                ? (_r = users.find((u) => u.id === dealUser)) === null || _r === void 0 ? void 0 : _r.fullname
                                : (_s = deal.user) === null || _s === void 0 ? void 0 : _s.fullname }),
                        React.createElement(Icon, { value: "pen-to-square" })))))),
        openModalAssignTo && (React.createElement(DealReassignModal, { onClose: onClose, onConfirm: onConfirmReassign, deal: deal })),
        openModalTitle && React.createElement(DealModalEditTitle, { onClose: onClose }),
        React.createElement("div", { className: "deal-sidebar-foot" },
            React.createElement(Requires, { permission: 'deal.update' }, deal.orderIn === true ? (React.createElement(ButtonGroup, { style: "column" },
                React.createElement(Button, { size: "large", picto: "check", label: t('Ordered'), disabled: deal.orderIn === true }))) : !user.isContactUser() && deal.stage === 'PENDING_APPROVAL' ? (React.createElement(ButtonGroup, { style: "column" },
                React.createElement(Button, { size: "large", picto: "check", className: "deal-sidebar-approve", label: t('Approve'), onPress: props.onApprove }))) : !isPublish ? (React.createElement(ButtonGroup, { style: "column" },
                React.createElement(Button, { size: "large", picto: "save", label: t('Save'), onPress: onSaveDraft, processing: saveDraftProcessing, disabled: saveDraftProcessing || !canSaveDraft, submit: true }),
                React.createElement(Button, { size: "large", style: "primary", picto: "share-square", label: t('Send'), onPress: onPublish, disabled: !canPublish }))) : (React.createElement(ButtonGroup, { style: "column" },
                React.createElement(Button, { size: "large", picto: "save", label: t('Save'), onPress: onPublish }),
                React.createElement(Button, { size: "large", picto: "check", label: t('Sent'), className: "deal-sidebar-published" }))))))) : (React.createElement(DealActivityStream, { setActivityStream: setActivityStream, setActivityStreamSideBar: setActivityStreamSideBar, entityData: entityData, deal: deal, entityType: entityType }))));
}
